module.exports = {

    API_URL : "https://api.respimatters.com/appointment_system",
    // API_URL : "http://localhost:3002/api",
    // API_URL : "http://localhost:3026/appointment_system",

    SITE_KEY : process.env.REACT_APP_SITE_KEY,

}